import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { codeBlock } from '@atlaskit/adf-schema';
import { convertToInlineCss } from '@atlaskit/editor-common/lazy-node-view';
import { CodeBlockSharedCssClassName } from '@atlaskit/editor-common/styles';
var codeBlockClassNames = {
  container: CodeBlockSharedCssClassName.CODEBLOCK_CONTAINER,
  start: CodeBlockSharedCssClassName.CODEBLOCK_START,
  end: CodeBlockSharedCssClassName.CODEBLOCK_END,
  contentWrapper: CodeBlockSharedCssClassName.CODEBLOCK_CONTENT_WRAPPER,
  content: CodeBlockSharedCssClassName.CODEBLOCK_CONTENT
};
var MATCH_NEWLINES = new RegExp('\n', 'gu');

// Based on: `packages/editor/editor-plugin-code-block/src/nodeviews/code-block.ts`
var _toDOM = function toDOM(node, formattedAriaLabel) {
  var totalLineCount = 1;
  node.forEach(function (node) {
    var text = node.text;
    if (text) {
      totalLineCount += (node.text.match(MATCH_NEWLINES) || []).length;
    }
  });
  var maxDigits = totalLineCount.toString().length;
  var content = node.textContent.split('\n').map(function (_, i) {
    return i + 1;
  }).join('\n');
  return ['pre', {
    class: codeBlockClassNames.container,
    style: "--lineNumberGutterWidth:".concat(maxDigits, "ch;"),
    'data-language': node.attrs.language || ''
  }, ['div', {
    class: codeBlockClassNames.start,
    contenteditable: 'false'
  }], ['div', {
    class: codeBlockClassNames.contentWrapper
  }, ['div', {
    // Based on packages/editor/editor-common/src/styles/shared/code-block.ts
    // But we can't reuse that class as it adds a ::before that intefers with this approach
    style: convertToInlineCss({
      backgroundColor: "var(--ds-background-neutral, #091E420F)",
      position: 'relative',
      width: 'var(--lineNumberGutterWidth, 2rem)',
      padding: "var(--ds-space-100, 8px)",
      flexShrink: 0,
      fontSize: '0.875rem',
      boxSizing: 'content-box'
    }),
    contenteditable: 'false'
  }, ['div', {
    class: 'code-block-gutter-pseudo-element',
    style: convertToInlineCss({
      textAlign: 'right',
      color: "var(--ds-text-subtlest, #626F86)",
      fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
      whiteSpace: 'pre-wrap'
    }),
    'data-label': content
  }]], ['div', {
    class: codeBlockClassNames.content
  }, ['code', {
    'data-language': node.attrs.language || '',
    spellcheck: 'false',
    'data-testid': 'code-block--code',
    'aria-label': formattedAriaLabel
  }, 0]]], ['div', {
    class: codeBlockClassNames.end,
    contenteditable: 'false'
  }]];
};
export var codeBlockNodeWithFixedToDOM = function codeBlockNodeWithFixedToDOM() {
  return _objectSpread(_objectSpread({}, codeBlock), {}, {
    toDOM: function toDOM(node) {
      return _toDOM(node, '');
    }
  });
};